import React from 'react';
import {FormattedMessage} from 'react-intl';

import {ENTITY_TYPE_PERFORMER, ENTITY_TYPE_CATEGORY, ENTITY_TYPE_GROUPING} from '@stubhub/entity-helper';

export const titles = {
  [ENTITY_TYPE_PERFORMER]: (
    <FormattedMessage
      id="EntitiesSeoLinks.title.PERFORMER"
      defaultMessage="Performers"
      description="The heading text for the PERFORMER child seo links"
    />
  ),
  [ENTITY_TYPE_CATEGORY]: (
    <FormattedMessage
      id="EntitiesSeoLinks.title.CATEGORY"
      defaultMessage="Categories"
      description="The heading text for the CATEGORY child seo links"
    />
  ),
  [ENTITY_TYPE_GROUPING]: (
    <FormattedMessage
      id="EntitiesSeoLinks.title.GROUPING"
      defaultMessage="Groupings"
      description="The heading text for the GROUPING child seo links"
    />
  ),
};
